import React from 'react';

const MonthlyAvgBadge: React.FC = () => (
  <span
    className="inline-flex items-center rounded-full bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-700 ring-1 ring-inset ring-amber-600/20"
    data-testid="monthly-avg-badge"
  >
    Monthly Avg
  </span>
);

export default MonthlyAvgBadge;
